import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

export const fetchCfcSubsidies = createAsyncThunk(
  "cfc/fetchCfcSubsidies",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/cfc-subsidies/${id}`);
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch CFC subsidies"
      );
    }
  }
);

const initialState = {
  data: {},
  current_tab: "particulars",
  data_loading: false,
  user_initiated_nav: false,
  error: null,
};

const cfcSlice = createSlice({
  name: "cfc",
  initialState,
  reducers: {
    setCfcData: (state, action) => {
      state.data = {
        ...(state.data || {}),
        ...(action.payload || {}),
      };
    },
    clearError: (state) => {
      state.error = null;
    },
    setCurrentTab: (state, action) => {
      state.current_tab = action.payload;
    },
    setDataLoading: (state, action) => {
      state.data_loading = action.payload;
    },
    setUserInitiatedNav: (state, action) => {
      state.user_initiated_nav = action.payload;
    },
    resetCfcState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCfcSubsidies.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchCfcSubsidies.fulfilled, (state, action) => {
        state.data_loading = false;
        state.data = action.payload || {};
      })
      .addCase(fetchCfcSubsidies.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setCfcData,
  setCurrentTab,
  setDataLoading,
  clearError,
  resetCfcState,
  setUserInitiatedNav,
} = cfcSlice.actions;
export default cfcSlice.reducer;
